import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["className", "shadow", "borderless", "outline", "type", "size", "children", "submit", "iconLeft", "iconRight", "iconFarRight", "innerRef", "loading", "block", "text", "round", "dataTest"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createElement, forwardRef } from 'react';
import Link from '../Link';
import cx from 'classnames';
import styles from './Button.m.sass';
var ForwardedLink = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/createElement(Link, _objectSpread(_objectSpread({}, props), {}, {
    innerRef: ref
  }));
});
var Button = function Button(_ref) {
  var className = _ref.className,
    shadow = _ref.shadow,
    borderless = _ref.borderless,
    outline = _ref.outline,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'normal' : _ref$size,
    children = _ref.children,
    submit = _ref.submit,
    iconLeft = _ref.iconLeft,
    iconRight = _ref.iconRight,
    iconFarRight = _ref.iconFarRight,
    innerRef = _ref.innerRef,
    loading = _ref.loading,
    block = _ref.block,
    text = _ref.text,
    round = _ref.round,
    dataTest = _ref.dataTest,
    rest = _objectWithoutProperties(_ref, _excluded);
  var classes = cx(styles.button, className, styles[type] || styles.default, styles["size-".concat(size)] || styles['size-normal'], shadow && styles.shadow, borderless && styles.borderless, outline && styles.outline, block && styles.block, text && styles.text, loading && styles.loading, round && styles.round);
  return /*#__PURE__*/createElement(submit ? 'button' : ForwardedLink, _objectSpread(_objectSpread({
    ref: innerRef,
    className: classes
  }, submit && {
    type: 'submit'
  }), {}, {
    'data-test': dataTest
  }, rest), iconLeft && /*#__PURE__*/createElement('span', {
    className: styles.iconLeft
  }, iconLeft), children, iconRight && /*#__PURE__*/createElement('span', {
    className: styles.iconRight
  }, iconRight), iconFarRight && /*#__PURE__*/createElement('span', {
    className: styles.iconFarRight
  }, iconFarRight));
};
export default Button;
//# sourceMappingURL=index.js.map
